import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function LegalNotice() {
  const { lang } = useLang();

  return (
    <div style={{ background: '#0A0B0F', minHeight: '100vh' }} className="py-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link 
          to={`/${lang}`}
          className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#BFC3C9] transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          <span>{lang === 'ru' ? 'Назад на главную' : 'Volver a inicio'}</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-white mb-8 font-heading">
          {lang === 'ru' ? 'Правовая информация' : 'Aviso Legal'}
        </h1>

        <div className="prose prose-invert max-w-none">
          {lang === 'ru' ? (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Данные компании</h2>
                <p className="text-[#BFC3C9] mb-2">
                  В соответствии со статьей 10 Закона 34/2002 от 11 июля об услугах информационного общества и электронной коммерции сообщаем следующие данные:
                </p>
                <ul className="text-[#BFC3C9] space-y-2">
                  <li><strong>Наименование:</strong> KIDS MAFIA SL</li>
                  <li><strong>NIF:</strong> B22815575</li>
                  <li><strong>Адрес:</strong> Calle Puebla de Valverde 4, 46014 Valencia, Spain</li>
                  <li><strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a></li>
                  <li><strong>Телефон:</strong> +34 624 586 917</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Условия использования</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Настоящий веб-сайт предоставляет информацию о франшизе KidsMafia. Использование сайта подразумевает полное принятие настоящих условий использования.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Интеллектуальная собственность</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Все содержимое данного веб-сайта, включая, но не ограничиваясь, текстами, графикой, логотипами, изображениями и программным обеспечением, является собственностью KIDS MAFIA SL или его поставщиков содержания и защищено законами об авторском праве и интеллектуальной собственности.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Юрисдикция</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Настоящие условия регулируются законодательством Испании. В случае возникновения спора стороны подчиняются юрисдикции судов города Валенсия.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Контакты</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Для любых вопросов, связанных с данным веб-сайтом, вы можете связаться с нами по адресу: <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a>
                </p>
              </section>
            </>
          ) : (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Datos de la Empresa</h2>
                <p className="text-[#BFC3C9] mb-2">
                  En cumplimiento con el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, se informa de los siguientes datos:
                </p>
                <ul className="text-[#BFC3C9] space-y-2">
                  <li><strong>Denominación social:</strong> KIDS MAFIA SL</li>
                  <li><strong>NIF:</strong> B22815575</li>
                  <li><strong>Domicilio social:</strong> Calle Puebla de Valverde 4, 46014 Valencia, Spain</li>
                  <li><strong>Correo electrónico:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a></li>
                  <li><strong>Teléfono:</strong> +34 624 586 917</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Condiciones de Uso</h2>
                <p className="text-[#BFC3C9] mb-4">
                  El presente sitio web proporciona información sobre la franquicia KidsMafia. El uso del sitio implica la aceptación plena de las presentes condiciones de uso.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Propiedad Intelectual</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Todo el contenido de este sitio web, incluyendo pero no limitándose a textos, gráficos, logotipos, imágenes y software, es propiedad de KIDS MAFIA SL o sus proveedores de contenido y está protegido por las leyes de derechos de autor y propiedad intelectual.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Jurisdicción</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Las presentes condiciones se rigen por la legislación española. En caso de disputa, las partes se someten a la jurisdicción de los tribunales de Valencia.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Contacto</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Para cualquier consulta relacionada con este sitio web, puede contactarnos en: <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a>
                </p>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
